/* ═══════════════════════════════════════════════════
   WHERE YOU LEFT OFF

   Reads the browsing history member-activity.js recorded and renders the
   member's most recent schemes. Everything is client-side because the history
   lives in their browser — Shopify never sees it, so Liquid can't render it.

   The whole section starts `hidden` and only reveals itself once there is
   something to show; a member who has never opened a scheme sees nothing
   rather than an empty shelf under a heading.
   ═══════════════════════════════════════════════════ */

(function () {
  var GAME_LABELS = { madden: 'Madden', cfb: 'CFB', both: 'Madden & CFB' };

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function initContinue(root) {
    if (!window.FilmStudyActivity) return;

    var grid = root.querySelector('[data-cw-grid]');
    if (!grid) return;

    var customerId = root.getAttribute('data-cw-customer') || '';
    var count = parseInt(root.getAttribute('data-cw-count'), 10);
    if (isNaN(count) || count < 1) count = 3;

    var entries = window.FilmStudyActivity.list(customerId, count);

    /* Nothing opened yet — leave the section hidden entirely. */
    if (!entries.length) {
      root.hidden = true;
      return;
    }

    grid.innerHTML = entries
      .map(function (entry) {
        var levelSuffix = entry.level === 'expert' ? '?level=expert' : '';
        var href = entry.url + (entry.url.indexOf('?') === -1 ? levelSuffix : '');

        var isTip = entry.kind === 'tip';

        /* Tips often have no image, so they get the book mark rather than the
           film-camera one — otherwise every tip card looks like a scheme. */
        var fallbackIcon = isTip
          ? '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></svg>'
          : '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m22 8-6 4 6 4V8Z"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>';

        var media = entry.image
          ? '<img src="' + esc(entry.image) + '" alt="" loading="lazy">'
          : '<div class="m-continue__card-fallback">' + fallbackIcon + '</div>';

        var tags = [];
        if (entry.game && GAME_LABELS[entry.game]) {
          tags.push('<span class="m-continue__tag">' + esc(GAME_LABELS[entry.game]) + '</span>');
        }
        if (isTip) {
          tags.push('<span class="m-continue__tag m-continue__tag--tip">Tip</span>');
        }
        if (entry.level) {
          tags.push(
            '<span class="m-continue__tag m-continue__tag--level">' +
              esc(entry.level === 'expert' ? 'Expert' : 'Beginner') +
              '</span>'
          );
        }

        return (
          '<a class="m-continue__card" href="' + esc(href) + '">' +
          '<div class="m-continue__card-media">' + media +
          (tags.length ? '<div class="m-continue__tags">' + tags.join('') + '</div>' : '') +
          '</div>' +
          '<div class="m-continue__card-body">' +
          '<p class="m-continue__card-title">' + esc(entry.title) + '</p>' +
          '<p class="m-continue__card-meta">Studied ' + esc(window.FilmStudyActivity.timeAgo(entry.ts)) + '</p>' +
          '<span class="m-continue__card-btn">Resume' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>' +
          '</span>' +
          '</div>' +
          '</a>'
        );
      })
      .join('');

    /* Greeting only makes sense for a signed-in member with a name on file. */
    if (root.getAttribute('data-cw-greeting') === 'true') {
      var block = root.querySelector('[data-cw-greeting-block]');
      var welcome = root.querySelector('[data-cw-welcome]');
      var firstName = (root.getAttribute('data-cw-first-name') || '').trim();
      if (block && welcome && firstName) {
        welcome.textContent = 'Welcome back, ' + firstName + '.';
        block.hidden = false;
      }
    }

    root.hidden = false;
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll ? container.querySelectorAll('.m-continue') : [];
    Array.prototype.forEach.call(roots, initContinue);
    if (container.classList && container.classList.contains('m-continue')) {
      initContinue(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* The Theme Editor swaps section markup over AJAX without re-running this
     file, so re-initialise on its lifecycle event (see the events calendar —
     same trap). */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
